import * as React from "react";
const SvgFiRrHammerCrash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hammer-crash_svg__a)">
      <path
        fill="#062147"
        d="m18.201 9.429.454-.874c.373-.72.441-1.54.191-2.31a2.94 2.94 0 0 0-1.474-1.736l-6.159-3.417C7.267-.96 4.303.342 2.887 1.3a1.99 1.99 0 0 0-.883 1.789A1.98 1.98 0 0 0 3.08 4.74l4.024 2.168-6.79 12.757a3.014 3.014 0 0 0 1.303 3.997 2.98 2.98 0 0 0 2.314.19 2.96 2.96 0 0 0 1.742-1.492L12.38 9.75l1.797.969a3 3 0 0 0 1.354.326 3.01 3.01 0 0 0 2.671-1.615zM3.894 21.445a1 1 0 0 1-.584.505 1 1 0 0 1-.77-.063c-.48-.25-.676-.847-.448-1.307L8.865 7.857l1.754.945zM16.88 7.633l-.453.874c-.253.485-.857.678-1.32.439L4.02 2.975c-.006-.003-.005-.015-.012-.018a5.43 5.43 0 0 1 3.07-.958c.93 0 1.996.235 3.19.854l6.172 3.424a.996.996 0 0 1 .44 1.356M24 6a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m-3.947 7.384A.998.998 0 0 1 19.267 15a1 1 0 0 1-.788-.384l-.783-1a1 1 0 0 1 .171-1.403.997.997 0 0 1 1.403.17zm2.938-2.393a1 1 0 0 1-1.362.38l-.888-.5a1 1 0 0 1 .982-1.742l.888.5a1 1 0 0 1 .38 1.362"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hammer-crash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHammerCrash;
